import io from "socket.io-client";
import { SESSION_TOKEN, SOCKET_EVENTS } from "../../constants/textConstants";
import { decrypt } from "../../utils/encryption";

let socket;



export const connectToSocket = () => {    
    //REACT_APP_SERVER_URL is the Server URL for API calls
    socket = io(
        `${process.env.REACT_APP_SERVER_URL}/operator`,
        {
            transports: ["websocket"],
            query: {
                token: decrypt(localStorage.getItem(SESSION_TOKEN))

            }
        });
    return socket;
}

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
    }
}

export const sendMessage = (message, customerId, type) => {
    let data = {
        message,
        type: type ? type : "text",
        from: "bot",
        interactionType: "live_agent",
        sentAt: Date.now()
    }

    if (socket) {
        socket.emit(SOCKET_EVENTS.SEND_OPERATOR_MESSAGE, {
            data,
            customerId
        })
    }
    return data;
}


export const agentConnection = (connectionFlag, customerId) => {

    if (socket) {
        socket.emit(SOCKET_EVENTS.AGENT_CONNECTION, {
            connectionFlag,
            customerId
        })
    }
}


export const agentTyping = (typingFlag, customerId) => {

    if (socket) {
        socket.emit(SOCKET_EVENTS.AGENT_TYPING, {
            typingFlag,
            customerId
        })
    }
}